// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"b8355a41","38":"48782407","115":"a7556148","120":"584508db","129":"8b9bdd3f","141":"488d259e","315":"97d25fe7","334":"e2c74047","409":"06aeaffa","514":"7966fe13","522":"6e6e444f","613":"be7034d3","739":"afb5deae","864":"dd9ad463"}[chunkId] + ".chunk.js";
};